import React from 'react';
import PropTypes from 'prop-types';
import SmorgCompanionSubscribeDefaultContent from './smorg_companion_subscribe_default_content';
import { useGetPublicSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';
import { SPACE_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const SmorgCompanionSubscribeContent = ({ spaceID }) => {
  const { data: currentSpace } = useGetPublicSpaceQuery(spaceID, {
    skip: !spaceID,
    refetchOnMountOrArgChange: SPACE_REFRESH_INTERVAL_SECONDS,
  });

  const content = currentSpace?.subscriptionBenefitsContent;

  const appTitle = currentSpace?.title;

  if (content) {
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return <SmorgCompanionSubscribeDefaultContent appTitle={appTitle} />;
};

SmorgCompanionSubscribeContent.propTypes = {
  spaceID: PropTypes.string.isRequired,
};

export default SmorgCompanionSubscribeContent;
